import styled from "styled-components";

export const NavBarLogoImg = styled.img`
  height: 5vh;
  cursor: pointer;
`;
